
define('ldsh!modules/accounts/status/products/mdirector/balance/transfer/result/template', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (model.isRequest) { ;
__p += '\n  <div class="spinner__container mt48 mb48">\n    <i class="ri-loader-4-fill fa-spin"></i>\n  </div>\n';
 } else if (responseOk) { ;
__p += '\n  <div id="messages-container">\n    <div class="notification alert alert-success flex align-center gap-12">\n      <i class="ri-check-line"></i>\n      <div class="i18n" data-i18n="ACCOUNTS.STATUS.MDIRECTOR.BALANCE.SUCCESS"></div>\n    </div>\n  </div>\n';
 } else { ;
__p += '\n  <div id="messages-container">\n    <div class="notification alert alert-danger flex align-center gap-12">\n      <i class="ri-close-line"></i>\n      <div class="i18n" data-i18n="ACCOUNTS.STATUS.MDIRECTOR.BALANCE.ERROR"></div>\n    </div>\n  </div>\n';
 } ;
__p += '\n\n<div class="flex align-center justify-end">\n  <button id="accept-balance" class="btn--primary" data-dismiss="modal">\n    <span class="i18n" data-i18n="ACCOUNTS.STATUS.MDIRECTOR.BALANCE.RESULT.ACCEPT"></span>\n  </button>\n</div>\n';

}
return __p
};});

